import React, {FC, useContext, useState} from "react";
import { useNavigate } from "react-router-dom";

import { UserContext } from "features/account";
import { useVerificationAccess } from "features/credits";
import Alert from "shared/ui/Alert";
import BuyCreditsCard from "components/BuyCreditsCard";
import IconSmile from "assets/img/icons/icon_smile.png";
import Button from "shared/ui/Button";
import {Button_Style, Button_Type} from "shared/ui/Button/Button";
import { ReactComponent as IconBack } from "assets/img/icons/icon_arrow-Right.svg";
import VideoFrame from "shared/ui/VideoFrame";
import Checkbox from "shared/ui/Checkbox";
import SponsorShipModal from "components/SponsorShipModal";


type VerifyOverViewProps = {
    showOverview: boolean;
    setShowOverview: any;
    setShowModal: any;
};

const VerifyOverviewDarkWeb: FC<VerifyOverViewProps> = ({
    showOverview = true,
    setShowOverview,
    setShowModal
}) => {
    const navigate = useNavigate();

    const { user, userType } = useContext(UserContext);
    const credits = user?.credits ?? 0;
    // Accès = solde OU vérifications gratuites du mois (règle unique, features/credits).
    const { canUse } = useVerificationAccess();
    const canVerify = credits > 0 || canUse;

    const [selectedNeverShowAgain, setSelectedNeverShowAgain] = useState(false);
    const [showSponsorModal, setShowSponsorModal] = useState<boolean>(false);



    const handleStartDarkWeb = () => {
        setShowOverview(false);
        localStorage.setItem("VerifyOverviewDarkWeb", JSON.stringify(!selectedNeverShowAgain));
    };

    const checkSelect = () => {
        const newSelect = !selectedNeverShowAgain;
        setSelectedNeverShowAgain(newSelect);
    };


    return (
        <>
            <div className="VerifyOverview h-100">
                <div className="content__body h-100">
                    <div className="row flex-wrap">
                        <div className={`col-sm-4`}>
                            <div className="content--card relative h-100">
                                <div className="mb-2">
                                    Des vérifications sont nécessaires pour contrôler un document
                                    d’identité.
                                    <br/>
                                    1 vérification = 1 document contrôlé
                                </div>
                                {!canVerify ? (
                                    <div className="VerifyResult card">
                                        <Alert type="error">Vous n'avez plus de vérification disponible.
                                            Veuillez en acheter.</Alert>
                                        <BuyCreditsCard showSponsorModal={showSponsorModal} setShowSponsorModal={setShowSponsorModal}/>
                                    </div>
                                ) : (
                                    <div className="h-70 d-flex flex-column justify-content-between align-items-center">
                                        <Alert type="info" showDefaultIcon={false}>
                                            <div
                                                className="d-flex flex-column justify-content-center align-items-center">
                                                <div className="text-primary"><img src={IconSmile} alt="smile"
                                                                                   width={30}/></div>
                                                <div className="text-center">
                                                    Vous avez <b>{credits}</b> credit-s disponibles pour vos
                                                    vérifications sur le dark Web
                                                </div>
                                                {/*<Button
                                                label="Acheter des vérifications"
                                                size="M"
                                                style={Button_Style.OUTLINED}
                                                onClick={() => handlePayCredit()}
                                            />*/}
                                            </div>
                                        </Alert>
                                        <Checkbox
                                            label="Ne plus afficher cette page"
                                            onChange={checkSelect}
                                            checked={selectedNeverShowAgain}
                                        />
                                        <Button
                                            type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                                            label="Dark Web"
                                            style={Button_Style.SOLID}
                                            onClick={() => handleStartDarkWeb()}
                                            icon={<IconBack
                                                className="PageHeader__icon"
                                                fill={"#9FC1EF"}
                                            />}
                                        />
                                        <br/>
                                    </div>
                                )
                                }

                            </div>
                        </div>
                        <div className="col-sm-8">
                            <div className="mt-3">
                                <VideoFrame
                                    url="https://www.youtube.com/watch?v=bYk4QPlCi5g"
                                    // prevImg={ImagePrev}
                                >
                                    <span className="text-primary bold">Dark Web :</span>
                                    <span className="text-danger"> Découvrez le fonctionnement notre Dark Web</span>
                                </VideoFrame>
                            </div>
                        </div>
                    </div>
                </div>
                {
                showSponsorModal && (
                    <SponsorShipModal isOpen={showSponsorModal}
                    onClose={() => setShowSponsorModal(false)}
                    />
                )
                }
            </div>

        </>

    );
};
export default VerifyOverviewDarkWeb;